import { App } from "vue";
import { message, Modal } from "ant-design-vue";

export function setupGlobalMethods(app: App) {
  app.config.globalProperties = {
    setGlobalfn: function () {
      let dom =
        document.querySelector(".ant-modal-content  .modal-page") ||
        document.querySelector("main.layout-content > .tabs-view .tab-scroll-container") ||
        document.querySelector(".ant-modal-content") ||
        document.body;
      console.log("dom", dom);
      return dom;
    },
  };
}
